<div mat-dialog-title>
	{{'DialogDeleteConfirmation.Title'|translate}}
</div>

<mat-dialog-content>
	{{confirmMessage}}
</mat-dialog-content>

<mat-dialog-actions>
	<button mat-stroked-button color="accent"
		(click)="close()">{{'DialogDeleteConfirmation.CancelButton'|translate}}</button>
	<button mat-raised-button color="accent"
		(click)="save()">{{'DialogDeleteConfirmation.ValidButton'|translate}}</button>
</mat-dialog-actions>